import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "M5.755 3.722h10.489v10.216l-2.724.34V6.446H6.028z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.99 3.7a.7.7 0 0 1 .7-.7H16.3a.7.7 0 0 1 .7.7v10.61a.7.7 0 0 1-.7.7h-2.174v1.29a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V6.574a.7.7 0 0 1 .7-.7h1.29zm1.4 2.174h7.036a.7.7 0 0 1 .7.7v7.037H15.6V4.4H6.39zm-1.99 1.4v5.203c1.926-.767 5.152-1.358 8.326-.415V7.274zm8.326 6.258c-3.245-1.12-6.693-.328-8.32.472l-.006.003V15.6h8.326z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.332 9.534a.777.777 0 1 1-1.554 0 .777.777 0 0 1 1.554 0"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ContentLibraryIcon20.js.map